module.exports = __webpack_public_path__ + "img/2-1.a57d8df4.jpg";